import React from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css"; // your existing CSS file
import { Helmet } from "react-helmet";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
        <Helmet>
        <title>Rebus Capital Management</title>
      </Helmet>
      {/* Navbar */}
      <nav className="navbar">
        <a href="/" className="logo">
          <img src="/RCM-Logo-White.png" alt="RCM Logo"/>
        </a>

        <div className="nav-spacer"></div>

        <button
          className="login-button"
          onClick={() => navigate("/login")}
        >
          Login
        </button>
      </nav>

      {/* Full-screen background */}
      <div className="background-container">
        {/* Optional video background */}
        {/*
        <video autoPlay loop muted className="background-video">
          <source src="new-york-cityscape.mp4" type="video/mp4" />
        </video>
        */}
        {/* Image background */}
        <img
          src="new-york-skyline.png"
          alt="New York City"
          className="background-image"
        />
      </div>

      {/* Footer */}
      <footer>
        <p>&copy; 2026 Rebus Capital Management LLC | All rights reserved.</p>
      </footer>
    </div>
  );
}
